import React, { Fragment, useEffect, useState } from "react";
import { CardBody, Col, Row, Table } from "reactstrap";

import {
  // Table as ReactTable,
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  flexRender,
  getExpandedRowModel,
} from "@tanstack/react-table";

import { rankItem } from "@tanstack/match-sorter-utils";

import { ProductsGlobalFilter } from "../../Components/Common/GlobalSearchFilter";
import { TablePagination, Tooltip } from "@mui/material";
import moment from "moment";
import { orderStatus } from "../../Components/constants/layout";
import { Link } from "react-router-dom";

const DebouncedInput = ({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [debounce, onChange, value]);

  return (
    <input
      {...props}
      value={value}
      id="search-bar-0"
      className="form-control search"
      onChange={(e) => setValue(e.target.value)}
    />
  );
};

// Column Filter
const Filter = ({
  column,
  // table
}) => {
  const columnFilterValue = column.getFilterValue();

  return (
    <>
      <DebouncedInput
        type="text"
        value={columnFilterValue ?? ""}
        onChange={(event) => column.setFilterValue(event.target.value)}
        placeholder="Search..."
        className="w-36 border shadow rounded"
        list={column.id + "list"}
      />
      <div className="h-1" />
    </>
  );
};

const TableContainer = ({
  columns,
  data,
  pagination,
  tableClass,
  theadClass,
  trClass,
  thClass,
  divClass,
  onGetPage,
  onSearch,
  onCustomerOrderClick,
  onCustomerCancelClick,
}) => {
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const { currentPage, pageSize, totalItems, totalPages } = pagination;
  const [expanded, setExpanded] = useState({});
  const fuzzyFilter = (row, columnId, value, addMeta) => {
    const itemRank = rankItem(row.getValue(columnId), value);
    addMeta({
      itemRank,
    });
    return itemRank.passed;
  };

  const table = useReactTable({
    columns,
    data,
    filterFns: {
      fuzzy: fuzzyFilter,
    },
    manualPagination: true,
    rowCount: totalItems,
    pageCount: totalPages,
    state: {
      expanded,
      columnFilters,
      globalFilter,
      pageIndex: currentPage,
      pageSize: pageSize,
    },
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    globalFilterFn: fuzzyFilter,
    onExpandedChange: setExpanded,
    getSubRows: (originalRow) => originalRow.orders,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  const { getHeaderGroups, getRowModel, setPageIndex, setPageSize } = table;

  const getOrderStatus = (order) => {
    if (order.ordCancellationReason)
      return (
        <span
          style={{ width: "100px" }}
          className="badge text-uppercase text-dark bg-danger "
        >
          Cancelled
        </span>
      );

    switch (order.ordStatus) {
      case orderStatus.STATUS_ACTIVE:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-uppercase text-dark bg-warning"
          >
            Pending
          </span>
        );
      case orderStatus.STATUS_ORDERED:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-uppercase text-dark bg-success"
          >
            Ordered
          </span>
        );
      case orderStatus.STATUS_CANCELLED:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-uppercase text-dark bg-danger "
          >
            Cancelled
          </span>
        );
      case orderStatus.STATUS_SHIPPED:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-uppercase text-dark bg-success"
          >
            SHIPPED
          </span>
        );
      case orderStatus.STATUS_EXPIRED:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-uppercase text-dark bg-danger"
          >
            Expired
          </span>
        );
      case orderStatus.STATUS_MOQNOTMET:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-uppercase text-dark bg-warning"
          >
            MOQ Not Met
          </span>
        );
      case orderStatus.STATUS_MOVNOTMET:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-uppercase text-dark bg-warning"
          >
            MOV Not Met
          </span>
        );
      case orderStatus.STATUS_MOQ_MET:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-uppercase text-dark bg-success"
          >
            MOQ Met
          </span>
        );
      case orderStatus.STATUS_MOV_MET:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-uppercase text-dark bg-success"
          >
            MOV Met
          </span>
        );
      case 12:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-uppercase text-dark bg-danger"
          >
            Payment failed
          </span>
        );
      default:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-uppercase bg-warning text-dark"
          >
            {" "}
            {order.ordStatus}{" "}
          </span>
        );
    }
  };
  const renderSubComponent = ({ row }) => {
    return (
      <Table
        hover
        className={tableClass}
        style={{ backgroundColor: "lightyellow" }}
      >
        <thead className="table-light text-uppercase text-dark">
          <tr className={trClass}>
            <th className={thClass}> Customer Order #</th>
            <th className={thClass}> Cartzy #</th>
            <th className={thClass}> Customer</th>
            <th className={thClass}> Ordered QTY</th>
            <th className={thClass}> Total Amount </th>
            <th className={thClass}> Date</th>
            <th className={thClass}> Status</th>
            <th className={thClass}> Action</th>
          </tr>
        </thead>
        <tbody>
          {row.original.orders.map((order) => {
            return (
              <tr key={order.ordId}>
                <td>
                  <Link
                    to="#"
                    className="text-primary fw-semibold"
                    onClick={() => {
                      const newOrder = {
                        ord_id: order.ordId,
                        ord_suo_id: order.ordSuoId,
                        ord_user_id: order.ordUserId,
                        ord_pro_id: 0,
                        ord_sup_id: 0,
                        ord_quantity: order.ordQuantity,
                        ord_totalPrice: order.ordTotalPrice,
                        ord_paymentIntentId: null,
                        ord_dateCreated: order.ordDateCreated,
                        ord_datePurchaseOrder: order.ordDatePurchaseOrder,
                        ord_status: order.ordStatus,
                        ord_cancellationReason: order.ordCancellationReason,
                        ord_cancellationReasonText:
                          order.ordCancellationReasonText,
                        ord_salesChannel: order.ordSalesChannel,
                        ord_MAP: order.ordMAP,
                        ord_extendedLeadTime: order.ordExtendedLeadTime,
                        ord_importantNotes: order.ordImportantNotes,
                        ord_restrictedChannel: order.ordRestrictedChannel,
                        pro_salesChannel: 0,
                        productName: row.original.productName,
                        productASIN: row.original.productASIN,
                        productUPC: row.original.productUPC,
                        productURL: row.original.productURL,
                        supplierName: row.original.supplierName,
                        userName: order.ordUserName,
                        userEmail: "",
                      };
                      onCustomerOrderClick(newOrder);
                    }}
                  >
                    {order.ordId}
                  </Link>
                </td>
                <td>
                  {order.ordBC10OrderId == 0 ? "N/A" : order.ordBC10OrderId}
                </td>
                <td>{order.ordUserName}</td>
                <td>{order.ordQuantity}</td>
                <td>
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(order.ordTotalPrice)}
                </td>
                <td>
                  <>
                    {moment(order.ordDateCreated).format("MM/DD/YYYY")}
                    <br />
                    <small className="text-muted">
                      {"     "}
                      {moment(order.ordDateCreated).format("hh:mm A")}
                    </small>
                  </>
                </td>
                <td>{getOrderStatus(order)}</td>
                <td>
                  <div className="d-flex gap-2">
                    <Tooltip title="View Details">
                      <Link
                        to="#"
                        className="text-primary d-inline-block"
                        onClick={() => {
                          const newOrder = {
                            ord_id: order.ordId,
                            ord_suo_id: order.ordSuoId,
                            ord_user_id: order.ordUserId,
                            ord_pro_id: 0,
                            ord_sup_id: 0,
                            ord_quantity: order.ordQuantity,
                            ord_totalPrice: order.ordTotalPrice,
                            ord_paymentIntentId: null,
                            ord_dateCreated: order.ordDateCreated,
                            ord_datePurchaseOrder: order.ordDatePurchaseOrder,
                            ord_status: order.ordStatus,
                            ord_cancellationReason: order.ordCancellationReason,
                            ord_cancellationReasonText:
                              order.ordCancellationReasonText,
                            ord_salesChannel: order.ordSalesChannel,
                            ord_MAP: order.ordMAP,
                            ord_extendedLeadTime: order.ordExtendedLeadTime,
                            ord_importantNotes: order.ordImportantNotes,
                            ord_restrictedChannel: order.ordRestrictedChannel,
                            pro_salesChannel: 0,
                            productName: row.original.productName,
                            productASIN: row.original.productASIN,
                            productUPC: row.original.productUPC,
                            productURL: row.original.productURL,
                            supplierName: row.original.supplierName,
                            userName: order.ordUserName,
                            userEmail: "",
                          };
                          onCustomerOrderClick(newOrder);
                        }}
                      >
                        <i className="ri-eye-fill fs-16"></i>
                      </Link>
                    </Tooltip>
                    {order.ordStatus === orderStatus.STATUS_ACTIVE && (
                      <Tooltip title="Cancel Order">
                        <Link
                          to="#"
                          className="text-danger d-inline-block"
                          onClick={() => {
                            onCustomerCancelClick({ ...order, ord_id: order.ordId });
                          }}
                        >
                          <i className="ri-close-circle-fill fs-16"></i>
                        </Link>
                      </Tooltip>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  };

  useEffect(() => {
    pageSize && setPageSize(pageSize);
  }, [pageSize, setPageSize]);

  useEffect(() => {
    if (pagination) {
      setPageIndex(pagination.currentPage);
      setPageSize(pagination.pageSize);
    }
  }, [pagination]);

  const handleChangePage = (event, newPage) => {
    onGetPage(newPage, pageSize);
  };
  const handleChangeRowsPerPage = (event) => {
    setPageSize(parseInt(event.target.value, 10));
    onGetPage(0, parseInt(event.target.value, 10));
  };
  return (
    <Fragment>
      {data && data.length ? (
        <div className={divClass}>
          <Table hover className={tableClass}>
            <thead className={theadClass}>
              {getHeaderGroups().map((headerGroup) => (
                <tr className={trClass} key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                    <th
                      key={header.id}
                      className={thClass}
                      {...{
                        onClick: header.column.getToggleSortingHandler(),
                      }}
                    >
                      {header.isPlaceholder ? null : (
                        <React.Fragment>
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                          {{
                            asc: " ",
                            desc: " ",
                          }[header.column.getIsSorted()] ?? null}
                          {header.column.getCanFilter() ? (
                            <div>
                              <Filter column={header.column} table={table} />
                            </div>
                          ) : null}
                        </React.Fragment>
                      )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>

            <tbody>
              {getRowModel().rows.map((row) => {
                return (
                  <Fragment key={row.original.suoId}>
                    <tr key={row.original.suoId}>
                      {row.getVisibleCells().map((cell) => {
                        return (
                          <td
                            style={{
                              cursor:
                                cell.column.id === "supplierName" ||
                                cell.column.id === "productASIN"
                                  ? "pointer"
                                  : "default",
                            }}
                            key={cell.id}
                            onClick={() =>
                              (cell.column.id === "supplierName" ||
                                cell.column.id === "productASIN") &&
                              onSearch(cell.getValue())
                            }
                          >
                            {flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext()
                            )}
                          </td>
                        );
                      })}
                    </tr>
                    {row.getIsExpanded() && (
                      <tr>
                        {/* 2nd row is a custom 1 cell row */}
                        <td colSpan={row.getVisibleCells().length}>
                          {renderSubComponent({ row })}
                        </td>
                      </tr>
                    )}
                  </Fragment>
                );
              })}
            </tbody>
            <tfoot>
              <TablePagination
                sx={{ ml: "auto" }}
                rowsPerPageOptions={[
                  5,
                  10,
                  25,
                  50,
                  100,
                  { label: "All", value: -1 },
                ]}
                count={totalItems}
                page={currentPage}
                onPageChange={handleChangePage}
                rowsPerPage={pageSize}
                onRowsPerPageChange={handleChangeRowsPerPage}
                showFirstButton
                showLastButton
              />
            </tfoot>
          </Table>
        </div>
      ) : (
        <div className="py-4 text-center">
          <div>
            <lord-icon
              src="https://cdn.lordicon.com/msoeawqm.json"
              trigger="loop"
              colors="primary:#405189,secondary:#0ab39c"
              style={{ width: "72px", height: "72px" }}
            ></lord-icon>
          </div>

          <div className="mt-4">
            <h5>Sorry! No Orders Found</h5>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default TableContainer;
